import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  footer: {
    padding: theme.spacing(3, 0),
    backgroundColor: theme.palette.primary.main,
  },
  info: {
    textAlign: 'center',
    color: 'white',
  },
}));
